export default __webpack_public_path__ + "static/media/new-News.26c681da.jpg";